import type { FC } from 'react';
import { styled } from 'goober';

import { colors } from '@/theme/colors';
import type { FlexBoxProps } from '@/ui/flexbox/flexbox';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { SmallText } from '@/ui/typography/widgets';

interface WithLabelProps extends FlexBoxProps {
  labelText: string;
  labelPosition?: 'top' | 'bottom';
  isRequired?: boolean;
}

export const WithLabel: FC<WithLabelProps> = ({
  children,
  name,
  labelText,
  labelPosition = 'bottom',
  isRequired = false,
  ...props
}) => {
  const labelContent = (
    <Label color={colors.gray.c13}>
      {labelText}
      {isRequired && <RequiredIndicator>*</RequiredIndicator>}
    </Label>
  );

  return (
    <Flexbox name={name} direction="column" gap="8px" {...props}>
      {labelPosition === 'top' && labelContent}
      {children}
      {labelPosition === 'bottom' && labelContent}
    </Flexbox>
  );
};

const Label = styled(SmallText)`
  margin-left: 10px;
`;

const RequiredIndicator = styled('span')`
  color: ${({ theme }) => theme.colors.system.lowFit};
  margin-left: 2px;
`;
